<div class="snackbar" [class.show]="visible">
    <img *ngIf="icon" [src]="icon" alt="icon" class="snackbar-icon" />
    <span class="snackbar-msg">{{ message }}</span>
</div>
